import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackIDVEvents = useCallback(
    (eventName: TrackingEvent, error?: any) => {
      trackEvent(
        eventName,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
        },
        error,
      );
    },
    [trackEvent],
  );

  return {
    trackIDVEvents,
  };
};
